exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-pin-icon{display:block}adp-pin-icon.green .pin{background-color:#357b6b}adp-pin-icon.pink .pin,adp-pin-icon.purple .pin{background-color:#de007b}adp-pin-icon .pin{display:block;width:12px;height:12px;border-top-left-radius:50%;border-top-right-radius:50%;border-bottom-right-radius:50%;transform:rotate(-45deg);background-color:#357b6b}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpPinIcon/adpPinIcon.less
// module id = 702
// module chunks = 0